import { t } from 'i18next';
import { WhiteButton } from 'styledComponents/buttons';
import { CommonFlex, CommonText } from 'styledComponents/common';

import { UpdateUserRequestSidePanelComponentContainer } from '../../../styledComponents/members';
import { AddUserRequestButton } from '../UpdateUserStyles';
import UpdateRequestUserData from './updateRequestUserData';

const UpdateUserRequestSidePanelComponent = ({ toggle }) => {
  return (
    <UpdateUserRequestSidePanelComponentContainer>
      <CommonText color="#000000" fontWeight="700" fontSize={'16px'}>
        {t('changelog')}
      </CommonText>
      <UpdateRequestUserData title="new_data" type="new" />
      <UpdateRequestUserData title="old_data" type="old" />
      <CommonFlex margin="auto">
        <WhiteButton type="cancel" padding="0 30px" onClick={toggle}>
          {t('reject')}
        </WhiteButton>
        <AddUserRequestButton type="approve" width="fit-content" margin="auto">
          {t('update_changes')}
        </AddUserRequestButton>
      </CommonFlex>
    </UpdateUserRequestSidePanelComponentContainer>
  );
};

export default UpdateUserRequestSidePanelComponent;
